import { TimeFormatOptions, Timeslot } from '@griply/types';
import { format } from 'date-fns';

import { formatDurationLabel } from './format-duration-label';
import { formatTimeRange } from './format-time-range';
import { isNumber } from './is-number';

export type FormatTimeslotLabelOptions = {
  timeFormat: TimeFormatOptions;
  isNL: boolean;
};

export const formatTimeslotLabel = (
  timeslot: Timeslot | null | undefined,
  { timeFormat, isNL }: FormatTimeslotLabelOptions,
): string => {
  if (!timeslot) {
    return '';
  }

  const startDate = new Date();
  startDate.setHours(0, 0, 0, timeslot.startTime ?? 0);
  const endDate = new Date();
  endDate.setHours(
    0,
    0,
    0,
    (timeslot.startTime ?? 0) + (timeslot.duration ?? 0),
  );

  const hasStart = isNumber(timeslot.startTime);

  if (hasStart && timeslot.duration) {
    return formatTimeRange(startDate, endDate, timeFormat);
  }

  return [
    hasStart ? format(startDate, timeFormat) : undefined,
    timeslot.duration && !hasStart
      ? formatDurationLabel(timeslot.duration, isNL)
      : undefined,
  ]
    .filter(Boolean)
    .join(' - ');
};
